const zh = {
	avatar: '头像',
	name: '姓名',
	eName: '英文名',
	cName: '中文名',
	phone: '手机号',
	tips: '提示：以下为同步来的信息，仅供参考',
};

export default zh;
